import React, { useEffect, useState } from 'react';
import PopupIcon from '../../assets/icons/popup.svg';

const PopupDisplay = ({ popup, onAllPopupsDismissed }) => {
  const [currentPopupIndex, setCurrentPopupIndex] = useState(0); // شاخص پاپ‌آپ فعلی
  const [dismissedPopups, setDismissedPopups] = useState([]); // وضعیت پاپ‌آپ‌های بسته‌شده

  useEffect(() => {
    // اگر پاپ‌آپ‌های باقی‌مانده وجود داشته باشد
    if (popup.length > 0 && currentPopupIndex < popup.length) {
      const timer = setTimeout(() => {
        // رفتن به پاپ‌آپ بعدی
        setCurrentPopupIndex((prevIndex) => prevIndex + 1);
      }, 120000); // 2 دقیقه

      return () => clearTimeout(timer); // پاک‌سازی تایمر هنگام تغییر
    }
  }, [currentPopupIndex, popup]);

  const handleDismissPopup = () => {
    // بستن پاپ‌آپ و رفتن به پاپ‌آپ بعدی
    const updatedDismissedPopups = [...dismissedPopups, popup[currentPopupIndex].id];
    setDismissedPopups(updatedDismissedPopups);

    if (updatedDismissedPopups.length === popup.length) {
      // تمام پاپ‌آپ‌ها بسته شدند
      setCurrentPopupIndex(popup.length); // به انتها می‌رسیم

      // فراخوانی تابع callback
      if (onAllPopupsDismissed) {
        onAllPopupsDismissed(); // اطلاع به کامپوننت اصلی
      }
    } else {
      setCurrentPopupIndex((prevIndex) => prevIndex); // رفتن به پاپ‌آپ بعدی
    }
  };

  
  // فیلتر کردن پاپ‌آپ‌هایی که بسته نشده‌اند
  const filteredPopups = popup.filter((item) => !dismissedPopups.includes(item.id));

  // اگر هیچ پاپ‌آپی برای نمایش باقی نمانده است، نمایش ندهیم
  if (filteredPopups.length === 0 || currentPopupIndex >= filteredPopups.length) {
    if(filteredPopups.length != 0){

      onAllPopupsDismissed(); // اطلاع به کامپوننت والد
    }
    return null;
  }

  const currentPopup = filteredPopups[currentPopupIndex];

  return (
    <>
    
    <div className="popup-item container web-popup">
      <div className="d-flex align-items-center gap-1 justify-content-between">
        <button
          className="btn-close"
          onClick={handleDismissPopup} // بستن پاپ‌آپ و رفتن به بعدی
          style={{ fontSize: '1rem', background: 'transparent', border: 'none', cursor: 'pointer' }}
        >
          ✖
        </button>
        <div className="d-flex align-items-center gap-1">
          <img src={PopupIcon} alt="" className="mx-4" />
          <h6 className="mb-0" style={{ fontSize: '16px', fontWeight: '500', color: '#494C50' ,fontFamily: 'yekan-bakh-medium !important'}}>
            {currentPopup.text}
          </h6>
        </div>
      </div>
      <div>
        <button
          className="btn btn-primary d-flex align-items-center gap-2 text-lg" style={{padding: '9px' ,minWidth: '170px',fontSize: '18px'}}
          onClick={() => {
            window.location.href = `${currentPopup.link}`;
          }}
        >
          {currentPopup.buttonText}
        </button>
      </div>
    </div>
    <div className="popup-item mobile-popup">
      <div className="d-flex align-items-center  justify-content-between">
        <button
          className="btn-close"
          onClick={handleDismissPopup} // بستن پاپ‌آپ و رفتن به بعدی
          style={{ fontSize: '1rem', background: 'transparent', border: 'none', cursor: 'pointer' }}
        >
          ✖
        </button>
        <div className="d-flex align-items-center ">
          <img src={PopupIcon} alt="" className="mx-2" />
          <h6 className="mb-0" style={{ fontSize: '12px', fontWeight: '400', color: '#494C50' }}>
            {currentPopup.text}
          </h6>
        </div>
      </div>
      <div>
        <button
          className="btn btn-primary "
          onClick={() => {
            window.location.href = `${currentPopup.link}`;
          }}
        >
          {currentPopup.buttonText}
        </button>
      </div>
    </div>
    </>
    
  );
};

export default PopupDisplay;
